import { createRoute } from "@tanstack/react-router";

import validation from "core/validation";

import { root } from "routes";
import Layout from "theme/ui/Layout";

import Interest from "areas/partners/pages/Interest";
import Signup from "areas/partners/pages/Signup";
import { query } from "areas/partners/data";


const _root = createRoute({
	getParentRoute: () => root,
	path: "partners"
});

const _lightLayout = createRoute({
	getParentRoute: () => _root,
	id: "partner-light",
	component: () => <Layout.Light />
});

const _darkLayout = createRoute({
	getParentRoute: () => _root,
	id: "partner-dark",
	component: () => <Layout.Dark />
});

const interest = createRoute({
	getParentRoute: () => _darkLayout,
	path: "/",
	component: () => <Interest />,
	staticData: {
		footer: "default"
	}
});

const signup = createRoute({
	getParentRoute: () => _lightLayout,
	path: "signup",
	beforeLoad: validation.redirect.unauthenticated,
	loader: async ({ context }) => {
		const { queryClient, profiles } = context;
		if (profiles.partner?.id) await queryClient.ensureQueryData(query.getStatus(profiles.partner.id));
		else await queryClient.ensureQueryData(query.getPermission());
	},
	component: () => <Signup />
});


const partners = _root.addChildren([
	_lightLayout.addChildren([signup]),
	_darkLayout.addChildren([interest])
]);

export default partners;